module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cMUjaN/tc-custom/CoverDesign.jpg?1685327317870?1718182737745",
      "alt": "This image is the cover for the book A Dom and His Artist, Club Whisper"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Dom and His Artist, Club Whisper\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Club Whisper Novel")])])]), _c('p', [_vm._v("Sometimes the perfect man can be found in the most unexpected place….")]), _c('p', [_vm._v("Martin Carmichael owns a security firm and is part owner of Club Whisper. He’s a Dom in search of the right guy, and when his car breaks down on a lonely stretch of road, he thinks he might have found him.")]), _c('p', [_vm._v("Artist Collin Malloy is talented, easygoing, but somewhat insecure. Still, he has a big heart and is quick to offer help when he sees Martin in need. To thank him, Martin invites Collin to dinner, where the attraction between them becomes harder to resist.")]), _c('p', [_vm._v("But what will become of their budding relationship when Martin reveals that he likes his men bound, submissive, and in pain? Is it something Collin can accept… and possibly enjoy exploring? Even if he can, Collin has a secret of his own—a secret he doesn’t even realize he’s keeping.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Xenia Melzer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0